export enum PhoneNumberTypeEnum {
  CELLULAR= 'CELLULAR',
  LOCAL = 'LOCAL',
  FAX = 'FAX',
}
